import {getJSONConfiguration} from "@utilities/config.helper";
import {Config} from "@commons/Config.class";

export const config = new Config(getJSONConfiguration());